module.exports = __webpack_public_path__ + "6f3118989bb6843da7589cb67e6c84e0.png";